import React from 'react';

interface MultiDeviceModalProps {
  onContinueHere: () => void;
  onCancel: () => void;
}

const MultiDeviceModal: React.FC<MultiDeviceModalProps> = ({ onContinueHere, onCancel }) => (
  <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-6 z-50">
    <div className="w-full max-w-sm bg-slate-900 border border-slate-700/60 rounded-2xl p-8 shadow-2xl text-center">
      <div className="w-14 h-14 rounded-full bg-amber-900/30 flex items-center justify-center mb-5 mx-auto">
        <svg className="w-7 h-7 text-amber-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
            d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      </div>

      <h2 className="text-white text-lg font-semibold mb-2">
        Already in this meeting
      </h2>
      <p className="text-slate-400 text-sm mb-8 leading-relaxed">
        You're already in this meeting on another device. Do you want to continue here instead?
      </p>

      <div className="flex gap-3">
        <button
          data-testid="multi-device-cancel"
          onClick={onCancel}
          className="flex-1 py-2.5 px-4 rounded-lg font-semibold text-slate-300 bg-slate-800 hover:bg-slate-700 transition-colors"
        >
          Cancel
        </button>
        <button
          data-testid="multi-device-continue"
          onClick={onContinueHere}
          className="flex-1 py-2.5 px-4 rounded-lg font-semibold text-white bg-teal-600 hover:bg-teal-500 transition-colors"
        >
          Continue Here
        </button>
      </div>
    </div>
  </div>
);

export default MultiDeviceModal;
